import { render, staticRenderFns } from "./MyServicesChip.vue?vue&type=template&id=05afbbd6&scoped=true"
import script from "./MyServicesChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyServicesChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyServicesChip.vue?vue&type=style&index=0&id=05afbbd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05afbbd6",
  null
  
)

export default component.exports